import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Notifications from './Notifications';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, error, message, currentPage, totalPage,
  } = state.notification;
  return {
    isLoading,
    data,
    error,
    message,
    currentPage,
    totalPage,
  };
}

const Styled = withStyles(styles)(Notifications);

export default connect(
  mapStateToProps,
)(Styled);
